(() => {
  const root=document.querySelector('[data-welcome]');
  if(!root) return;
  const dialog=root.querySelector('[data-welcome-dialog]'),launcher=root.querySelector('[data-welcome-launch]');
  const read=key=>{try{return localStorage.getItem(key)}catch{return null}};
  const write=(key,value)=>{try{localStorage.setItem(key,value)}catch{}};
  const clear=key=>{try{localStorage.removeItem(key)}catch{}};
  const pending='led-welcome-pending',dismissed='led-welcome-dismissed';
  let previousFocus=null,overflow='',timer=0;
  const open=()=>{
    if(dialog.open||typeof dialog.showModal!=='function')return;
    if(document.querySelector('dialog[open]'))return;
    previousFocus=document.activeElement;overflow=document.documentElement.style.overflow;
    dialog.showModal();document.documentElement.style.overflow='hidden';
  };
  const close=()=>{dialog.close();write(dismissed,String(Date.now()));clear(pending)};
  launcher.addEventListener('click',open);
  root.querySelectorAll('[data-welcome-close]').forEach(button=>button.addEventListener('click',close));
  dialog.addEventListener('cancel',()=>{write(dismissed,String(Date.now()));clear(pending)});
  dialog.addEventListener('close',()=>{document.documentElement.style.overflow=overflow;previousFocus?.focus({preventScroll:true})});
  dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const rect=dialog.getBoundingClientRect();if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)close()});
  root.querySelector('[data-welcome-account]')?.addEventListener('click',()=>write(pending,'1'));
  const form=root.querySelector('form');
  form?.addEventListener('submit',()=>{write(pending,'1')});
  const copy=root.querySelector('[data-welcome-copy]');
  copy?.addEventListener('click',async()=>{
    try{await navigator.clipboard.writeText(root.querySelector('[data-welcome-code]').textContent.trim());copy.textContent=copy.dataset.copied;root.querySelector('[data-welcome-status]').textContent=copy.dataset.copied}
    catch{const range=document.createRange();range.selectNodeContents(root.querySelector('[data-welcome-code]'));const selection=getSelection();selection.removeAllRanges();selection.addRange(range)}
  });
  if(root.dataset.editor==='true')return;
  const returning=read(pending)==='1'||new URLSearchParams(location.search).get('welcome')==='1';
  if(root.dataset.state==='ineligible'){if(returning)timer=setTimeout(open,400);else launcher.hidden=true;clear(pending);return}
  if(returning||root.querySelector('[data-welcome-success], .le-welcome-message')){timer=setTimeout(open,400);if(root.querySelector('[data-welcome-success], .le-welcome-message'))clear(pending)}
  
  window.addEventListener('pagehide',()=>clearTimeout(timer),{once:true});
})();
